import { createActionConfig } from './create-action-config';

export const type = '@appcues/close';
export const getClose = config =>
  createActionConfig({
    type,
    config,
  });
